module.exports = __webpack_public_path__ + "static/UIIcons@2x-c78d5c92043c9fc982331ca33f759fa0.jpg";